<template>
  <div
    class="checkout-step relative"
    :class="{ complete: complete && foldWhenCompleted }">
    <h4
      class="checkout-step-title"
      v-if="title && (!complete || !foldWhenCompleted)">
      {{ translateUcFirst(title) }}
    </h4>
    <div
      class="checkout-step-inner bg-bg border-thin-gray-2 border-radius-s"
      :class="{ complete: complete && !foldWhenCompleted }">
      <div
        class="checkout-step-content"
        :class="{
          foldable: foldWhenCompleted,
          complete: complete,
        }">
        <div v-if="!complete || !foldWhenCompleted" class="width-expand">
          <slot name="default"></slot>
        </div>
        <div
          v-if="complete && foldWhenCompleted"
          class="width-expand flex gap-m flex-middle">
          <icon-halo halo-theme="success" theme="bg" icon="check"></icon-halo>
          <span class="block">
            <h5 v-if="title && complete" class="margin-remove block text-l">
              {{ translateUcFirst(title) }}
            </h5>
            <slot name="complete"></slot>
          </span>
          <icon-halo
            class="edit-icon"
            halo-theme="inverse"
            theme="bg"
            icon="pencil"
            @click="$emit('checkout-step:request-edit')"></icon-halo>
        </div>
      </div>

      <div
        class="padding-l-horizontal padding-s-vertical transition"
        v-if="completionConditionText != '' && showCompletionHint && !(foldWhenCompleted && complete)"
        :class="complete ? 'bg-success' : 'bg-gray-2'"
        style="
          border-radius: 0 0 var(--border-radius-s) var(--border-radius-s);
        ">
        <div
          class="flex gap-s flex-middle animate__fadeIn animate--fastest"
          v-if="!complete">
          <icon icon="warning-triangle"></icon>
          <span class="bold">
            {{ completionConditionText }}
          </span>
        </div>
        <div
          class="flex gap-s flex-middle c-bg animate__fadeIn animate--fastest"
          v-if="complete">
          <icon icon="check"></icon>
          <span class="bold">נתונים תקינים, ניתן להמשיך</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CheckoutStep",
  props: {
    title: {
      type: [String, Boolean],
      default: false,
    },
    complete: {
      type: [Boolean],
      default: false,
    },
    foldWhenCompleted: {
      type: Boolean,
      default: true,
    },
    completionConditionText: {
      type: String,
      default: "",
    },
    showCompletionHint: {
      type: Boolean,
      default: true,
    },
  },
  data: function () {
    return {};
  },
  emits: ["checkout-step:request-edit"],
};
</script>

<style scoped lang="scss">
.checkout-step {
  .checkout-step-title {
    margin-bottom: var(--margin-m);
    font-weight: 200;
    font-size: var(--font-3xl);
  }

  .checkout-step-inner {
    &.complete {
      border: 1px solid var(--c-success);
    }
  }

  .checkout-step-content {
    padding: var(--margin-xl) var(--margin-l);

    &.foldable.complete {
      padding: 0;
    }
  }

  &.complete {
    border: 1px solid var(--c-success);

    .checkout-step-inner {
      padding: var(--margin-l) var(--margin-l);
    }
  }

  .edit-icon {
    position: absolute;
    cursor: pointer;
    top: 0;
    inset-inline-start: 0;
    transform: translateY(-50%) translateX(-50%);

    [dir="rtl"] & {
      transform: translateY(-50%) translateX(50%);
    }
  }
}
</style>
